import { render, staticRenderFns } from "./ProductRegroupment.vue?vue&type=template&id=2226ffa2&"
import script from "./ProductRegroupment.vue?vue&type=script&lang=js&"
export * from "./ProductRegroupment.vue?vue&type=script&lang=js&"
import style0 from "./ProductRegroupment.vue?vue&type=style&index=0&id=2226ffa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports